import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus } from "../../../utils";
import { RootState } from "../../../redux/store";
import { LinkyConsent } from "./linkyConsentsAPI";
import { fakeLinkyConsents } from "./linkyConsentsFakeData";

export interface LinkyConsentsState {
  linkyConsentsStatus: QueryStatus;
  linkyConsents: LinkyConsent[];
}

const initialState: LinkyConsentsState = {
  linkyConsentsStatus: "idle",
  linkyConsents: [],
};

export const getLinkyConsentsAsync = createAsyncThunk(
  "getLinkyConsentsAsync/call",
  () => {
    return fakeLinkyConsents;
  },
);

export const linkyConsentsSlice = createSlice({
  name: "linkyConsents",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLinkyConsentsAsync.pending, (state) => {
        state.linkyConsentsStatus = "processing";
      })
      .addCase(getLinkyConsentsAsync.fulfilled, (state, action) => {
        state.linkyConsentsStatus = "success";
        state.linkyConsents = action.payload;
      })
      .addCase(getLinkyConsentsAsync.rejected, (state) => {
        state.linkyConsentsStatus = "failed";
      });
  },
});

export const selectLinkyConsentsStatus = (state: RootState) =>
  state.linkyConsents.linkyConsentsStatus;

export const selectLinkyConsents = (state: RootState) =>
  state.linkyConsents.linkyConsents;

export default linkyConsentsSlice.reducer;
